import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import axios from 'axios';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const languages = [
    { code: 'en', name: 'English' },
    { code: 'ru', name: 'Русский' },
    { code: 'de', name: 'Deutsch' },
    { code: 'zh', name: '中文' },
    { code: 'ko', name: '한국어' }
  ];

  const current = languages.find(l => l.code === i18n.language) || languages[0];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="p-2.5 rounded-md hover:bg-zinc-900 transition-colors"
        title="Language"
      >
        <Globe className="w-4 h-4 text-zinc-500 hover:text-cyan-400" />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 bg-zinc-900 border border-zinc-700 rounded shadow-xl z-50 min-w-[130px]">
          {languages.map(({ code, name }) => (
            <button
              key={code}
              onClick={async () => {
                await i18n.changeLanguage(code);
                setOpen(false);
                try {
                  const token = localStorage.getItem('session_token');
                  if (token) {
                    await axios.post('/api/settings/filters', { language: code },
                      { headers: { Authorization: `Bearer ${token}` } }
                    );
                  }
                } catch (e) {
                  console.error('Failed to save language to server:', e);
                }
              }}
              className={`w-full text-left px-3 py-2 text-sm transition-colors ${
                i18n.language === code
                  ? 'text-cyan-400 bg-cyan-900/20'
                  : 'text-zinc-400 hover:text-zinc-200 hover:bg-zinc-800'
              }`}
            >
              {name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
